export default "__VITE_ASSET__92c0b067__"